module.exports = __webpack_public_path__ + "img/adapted_2_tn.e704ba2f.jpg";